// Email Validator
import {ValidatorResult} from "@/shared/models/form/fields/types";
import {BaseValidator} from "@/shared/models/form/fields/validators/validator.interface";

export class EmailValidator extends BaseValidator {
    private readonly emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    constructor(message: string = "invalidEmail") {
        super(message);
    }

    validate(value: string): ValidatorResult {
        if (!value?.trim()) {
            return this.success(); // Empty value is valid (use RequiredValidator to check empty)
        }

        return this.emailRegex.test(value) ? this.success() : this.fail();
    }
}
